<script lang="ts">
  import type { schema } from "@editor/schema";
  import { isRTL } from "sbelt/text";
  import { getNewsletterStores } from "../newsletterStores";

  import Block from "./Block.svelte";
  import { withDefaults } from "./utils";
  import { LinkContent, SVGRunningText } from "./utils";
  const { design } = getNewsletterStores();

  export let block: schema.TitleBlock;

  $: [blockWidthDefaults, isDefault] = withDefaults(block, { title: "Click to add a title" });

  $: fp = $design.fontPack["text.title"];
  $: color = block.title ? $design?.color["text.title"].text : "var(--color-secondary)";
  $: rtl = isRTL(blockWidthDefaults.title);
  $: align = rtl && blockWidthDefaults.align == "left" ? "right" : block.align;

  function defaultSize(layout: string) {
    switch (layout) {
      case "sm":
        return 20;
      case "md":
        return 28;
      case "lg":
        return 36;
    }
  }
</script>

<Block {block} on:click on:delete on:duplicate let:layout layouts={["sm", "md", "lg"]} let:isEmpty showEmpty>
  {@const size = fp[`${layout}Size`] || defaultSize(layout)}
  <h3 aria-label={blockWidthDefaults.title}>
    <LinkContent
      aria-label={blockWidthDefaults.title}
      cta={blockWidthDefaults.cta}
      linkText={blockWidthDefaults.title}
      blockId={blockWidthDefaults._id}
      class="block">
      <div aria-hidden="true">
        <SVGRunningText
          font={fp.customFont}
          text={blockWidthDefaults.title}
          {color}
          {align}
          {rtl}
          {size}
          letterSpacing={fp.letterSpacing}
          spaceTracking={fp.spaceTracking}
          lineHeight={fp.lineHeight} />
      </div>
    </LinkContent>
  </h3>
</Block>

<style>
  .top-line {
    height: 6px;
    width: 40px;
  }
</style>
